<script>
import {NodeIdEnum} from "@/enums/nodeIdEnum";
import {getImgList, selectArticleList} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";

export default {
  computed: {
    // 根据type值获取对应的分类名称（调用枚举的工具方法）
    currentArticleLabel() {
      return NodeIdEnum.getLabelByValue(this.articleType);
    },
  },
  data() {
    return {
      loading: false,
      topImgList:[],
      // 新增：文章列表数据
      articleList: [],
      // 新增：分页参数
      pageNum: 1,   // 当前页码
      pageSize: 5,      // 每页条数（首条1个 + 下部两列4个）
      total: 0,         // 总条数
      articleType: ""   // 当前文章类型
    }
  },
  created() {
    // 从路由获取文章类型，默认球馆案例
    this.articleType = this.$route.query.articleType;
    this.getBannerList();  //初始化获取图片
    this.getArticleList(); // 初始化获取文章列表
  },
  methods: {
    //获取图片
    async getBannerList() {
      try {
        this.loading = true;
        const res = await getImgList(ImageTypeEnum.TABLE_ARTICLE_LIST.value);
        const dataList = res.data || [];
        this.topImgList = dataList.filter(item => item.classify === ImageTypeEnum.TABLE_ARTICLE_LIST.value && item.src);
      } catch (error) {
        console.error("获取轮播图失败：", error);
        this.$message?.error("轮播图加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    // 新增：获取文章列表（带分页）
    async getArticleList() {
      try {
        this.loading = true;
        // 调用接口：传递分页+类型参数（需替换为你的实际接口参数）
        const res = await selectArticleList(this.articleType,this.pageNum,this.pageSize);
        if (res.code === 200) {
          this.articleList = res.data.rows || [];

          this.total = res.data.total || 0;
        } else {
          this.$message.error(res.msg || "获取文章列表失败");
        }
      } catch (error) {
        console.error("获取文章列表失败：", error);
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    // 新增：分页-切换每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1; // 切换条数后重置到第一页
      this.getArticleList();
    },

    // 新增：分页-切换当前页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getArticleList();
    }
  }
}
</script>

<template>
  <div class="container" v-loading="loading">
    <div class="inside-banner">
      <!-- ElementUI轮播图 -->
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item v-for="(item, index) in topImgList" :key="index">
          <a class="banner-link" href="" target="">
            <img
                :src="item.src"
                :alt="item.title"
                class="carousel-img"
            />
          </a>
        </el-carousel-item>
      </el-carousel>

      <!-- 面包屑 -->
      <div class="crumbs">
        <p>
          <a href="/home" target="">首页</a> /
          <a href="" target="">{{currentArticleLabel}}</a>
        </p>
      </div>
    </div>

    <div class="container-content">
      <!-- 1. 首条数据（独占一行） -->
      <div class="article-item article-first" v-if="articleList.length > 0">
        <div class="article-img">
          <img
              :src="articleList[0].thumbnail"
              :alt="articleList[0].title"
              class="first-img"
          />
        </div>
        <div class="article-content">
          <h2 class="article-title">{{ articleList[0].title }}</h2>
          <p class="article-date">{{ articleList[0].time.substring(0,10) }}</p>
          <p class="article-desc">{{ articleList[0].intro }}</p>
          <a
              :href="`/article?articleId=${articleList[0].id}&type=${articleList[0].type}`"
              class="article-link"
              target=""
          >活动详情></a>
        </div>
      </div>

      <!-- 2. 下部两列数据 -->
      <div class="article-grid" v-if="articleList.length > 1">
        <div
            class="article-item article-normal"
            v-for="(item, index) in articleList.slice(1)"
            :key="item.id"
        >
          <div class="article-img">
            <img
                :src="item.thumbnail"
                :alt="item.title"
                class="normal-img"
            />
          </div>
          <div class="article-content">
            <h2 class="article-title">{{ item.title }}</h2>
            <p class="article-date">{{ item.time.substring(0,10) }}</p>
            <p class="article-desc">{{ item.intro }}</p>
            <a
                :href="`/article?articleId=${item.id}&type=${item.type}`"
                class="article-link"
                target=""
            >活动详情></a>
          </div>
        </div>
      </div>

      <!-- 3. 分页组件 -->
      <div class="pagination" v-if="total > 0">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 15]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>

      <!-- 空数据提示 -->
      <div class="empty-tip" v-if="articleList.length === 0 && !loading">
        暂无相关文章
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
// 统一盒模型
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
// 基础浮动类（兼容旧类名）
.fl { float: left; }
.fr { float: right; }
// 清除浮动
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}

.container{
  position: relative;
  width: 100%;
  max-width: 1920px; // 限制最大宽度，适配大屏
  margin: 0 auto;
}

// Banner容器
.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    margin-top: 80px;
  }
  @media (max-width: 480px) {
    margin-top: 60px;
  }
}

// ElementUI轮播图容器样式
.banner-carousel {
  width: 100%;
  height: 280px !important;

  @media (max-width: 768px) {
    height: 200px !important;
  }
  @media (max-width: 480px) {
    height: 150px !important;
  }

  :deep(.el-carousel__container) {
    height: 100%;
  }

  :deep(.el-carousel-item) {
    height: 100%;
  }
}

// 轮播图链接
.banner-link {
  display: block;
  width: 100%;
  height: 100%;
}

// 轮播图图片样式
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

// 面包屑容器
.crumbs {
  position: absolute;
  bottom: 38px;
  left: 9%;
  width: 82%;
  padding: 20px 30px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 10;

  @media (max-width: 768px) {
    bottom: 20px;
    left: 5%;
    width: 90%;
    padding: 15px 20px;
  }
  @media (max-width: 480px) {
    bottom: 10px;
    padding: 10px 15px;
  }
}

// 面包屑文本
.crumbs p {
  color: #999;
  font-size: 12px;
  line-height: 20px;

  @media (max-width: 480px) {
    font-size: 11px;
  }
}

// 面包屑链接
.crumbs p a {
  display: inline-block;
  vertical-align: top;
  margin: 0 10px;
  color: #999;
  text-decoration: none;
  transition: color 0.2s ease;

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    color: #000;
  }

  @media (max-width: 480px) {
    margin: 0 5px;
  }
}

// 面包屑h2样式
.crumbs h2 {
  font-size: 30px;
  color: #555;
  margin: 0 0 8px 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
  @media (max-width: 480px) {
    font-size: 18px;
  }
}

.container-content {
  max-width: 1600px;
  margin: 50px auto;
  padding: 0 20px;

  // 首条文章样式（独占一行）
  .article-first {
    display: flex;
    gap: 24px;
    padding: 20px 0;
    border-bottom: 1px solid #eee;
    margin-bottom: 30px;

    .article-img {
      flex: 0 0 320px; // 首条图片固定宽度
      height: 200px;
      overflow: hidden;

      .first-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
        transition: transform 0.3s;
      }
      &:hover .first-img {
        transform: scale(1.03);
      }
    }

    .article-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 12px;

      .article-category {
        font-size: 14px;
        color: #d26b6b;
        margin: 0;
      }
      .article-title {
        font-size: 22px;
        font-weight: bold;
        color: #333;
        margin: 0;
        line-height: 1.5;
        transition: color 0.2s;
        &:hover {
          color: #d26b6b;
        }
      }
      .article-date {
        font-size: 14px;
        color: #999;
        margin: 0;
      }
      .article-desc {
        font-size: 16px;
        color: #666;
        margin: 0;
        line-height: 1.6;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .article-link {
        color: #d26b6b;
        text-decoration: none;
        font-size: 14px;
        margin-top: 8px;
        display: inline-block;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  // 两列文章网格
  .article-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 2% 2%; // 行/列间距

    .article-normal {
      width: 49%; // 两列布局，每列占49%
      margin-bottom: 30px;
      display: flex;
      gap: 15px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
      transition: background-color 0.2s;
      &:hover {
        background-color: #fafafa;
      }

      .article-img {
        flex: 0 0 120px; // 小图固定宽度
        height: 80px;
        overflow: hidden;

        .normal-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 4px;
          transition: transform 0.3s;
        }
        &:hover .normal-img {
          transform: scale(1.05);
        }
      }

      .article-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .article-category {
          font-size: 12px;
          color: #d26b6b;
          margin: 0;
        }
        .article-title {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin: 0;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          transition: color 0.2s;
          &:hover {
            color: #d26b6b;
          }
        }
        .article-date {
          font-size: 12px;
          color: #999;
          margin: 0;
        }
        .article-desc {
          font-size: 14px;
          color: #666;
          margin: 0;
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .article-link {
          color: #d26b6b;
          text-decoration: none;
          font-size: 12px;
          margin-top: 5px;
          display: inline-block;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  // 分页样式
  .pagination {
    margin-top: 40px;
    text-align: center;

    :deep(.el-pagination) {
      display: inline-block;
    }
  }

  // 空数据提示
  .empty-tip {
    text-align: center;
    padding: 50px 0;
    color: #999;
    font-size: 16px;
  }

  // 移动端响应式适配
  @media (max-width: 768px) {
    .article-first {
      flex-direction: column; // 首条改为上下布局
      .article-img {
        flex: 0 0 auto;
        height: auto;
      }
    }
    .article-grid {
      .article-normal {
        width: 100%; // 移动端改为单列布局
      }
    }
  }
}
</style>